import React from 'react';
import { Link } from '@chakra-ui/react';

/**
 * Plain text with its links made clickable — WhatsApp underlines them too.
 *
 * Lifted out of MessageBubble when the template renderer needed the same
 * behaviour: a template body regularly carries a URL, and a second copy of this
 * would be a second set of rules about what counts as a link.
 */
const URL_RE = /((?:https?:\/\/|www\.)[^\s<]+)/gi;
// A separate, non-global test: a global regex carries `lastIndex` between
// calls and would judge every other part wrongly.
const IS_URL = /^(?:https?:\/\/|www\.)/i;

export default function Linkify({ text }) {
	const parts = String(text).split(URL_RE);
	return (
		<>
			{parts.map((part, i) =>
				IS_URL.test(part) ? (
					<Link
						key={i}
						href={part.startsWith('http') ? part : `https://${part}`}
						isExternal
						color="info"
						textDecoration="underline"
						wordBreak="break-all"
						onClick={(e) => e.stopPropagation()}
					>
						{part}
					</Link>
				) : (
					<React.Fragment key={i}>{part}</React.Fragment>
				),
			)}
		</>
	);
}
